<template>
  <div id="app">
    <!-- <router-link to="/">列表</router-link>
    <router-link to="/about">模板</router-link> -->
    <Tabs value="list" @on-click="push">
        <TabPane label="商品列表" name="list"></TabPane>
        <TabPane label="价格模板" name="template"></TabPane>
    </Tabs>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import { Tabs, TabPane } from "iview";

export default {
  name: 'app',

  components: {
    Tabs, 
    TabPane
  },

  methods: {
    push(name) {
      if(name==='list') {
        this.$router.push('/')
      } else {
        this.$router.push('/about')
      }
    }
  },
}
</script>
<style lang="less">

</style>
